// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zQg4","newExpiryDate":"styles_newExpiryDate__37k9s","footer":"styles_footer__1uG6F"};